import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

var baseURL = "";
if (process.env.NODE_ENV === 'development') {
  baseURL = process.env.REACT_APP_LOCAL_URL + "/api/";
  console.log(baseURL)
}
if (process.env.NODE_ENV === 'production') {
  baseURL = process.env.REACT_APP_BACKEND_URL + "/api/";
}

export const apiService = createApi({
  reducerPath: "apiService",
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
  }),
  endpoints: () => ({}),
});

export default apiService;
